import {atom} from 'recoil';

export const loadingPageState = atom<boolean>({
    key: 'loadingPageState',
    default: false,
});
